var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { TransferService } from '@square/dashboard-protos/models/squareup/sfs/external/services/transfer/transfer_service';
import Service, { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import rpc, { apiHostUrl } from '@banking/api/utils/rpc';
import moment from 'moment';
const DEFAULT_LIST_TRANSACTIONS_PAGE_SIZE = 200;
let SfsTransferApi = (_dec = computed('capitalEngineContext.headers'), _class = class SfsTransferApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor2, this);
  }
  get client() {
    return TransferService.create(rpc(apiHostUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  createTransfer(transfer, idempotencyKey) {
    return this.client.createTransfer({
      transfer,
      idempotencyKey
    }).then(({
      transfer
    }) => {
      return transfer;
    });
  }
  listEstimatedTransferEvents(fromAccountId, toAccountId, timestamp, type) {
    return this.client.listEstimatedTransferEvents({
      fromAccountId,
      toAccountId,
      desiredCreationTime: moment(timestamp).format(),
      transferType: type
    }).then(response => {
      return response.transferEvents;
    });
  }
  listTransactions(accountId, pageNumber = 0, pageSize = DEFAULT_LIST_TRANSACTIONS_PAGE_SIZE, beginDate, endDate) {
    return this.client.listTransactions({
      accountId,
      pageSize,
      pageNumber,
      beginDate,
      endDate
    }).then(({
      transactions,
      hasMoreResults
    }) => {
      return {
        transactions,
        pageNumber: hasMoreResults ? pageNumber + 1 : null
      };
    });
  }
  async retrieveTransactionDetails(id, accountId) {
    const response = await this.client.retrieveTransactionDetails({
      id,
      accountId
    });
    return response.transactionDetails;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _class);
export { SfsTransferApi as default };